import React from "react";
import clsx from "clsx";
import { Link, useLocation } from "react-router-dom";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import { makeStyles } from "@material-ui/core/styles";
import { equals } from "ramda";

const useStyles = makeStyles(theme => ({
  root: {
    "&$selected": {
      backgroundColor: theme.palette.primary.contrastText,
    },

    "&$selected::after": {
      top: 18,
      left: -10,
      width: 30,
      height: "15%",
      position: "absolute",
      transform: "rotate(90deg)",
      background: theme.palette.primary.main,
      borderRadius: 20,
      content: "no-open-quote",
    },
    "&:hover": {
      color: "inherit",
    },
  },

  selected: {},

  itemText: {
    fontSize: "1.4rem",
    lineHeight: "1.8rem",
    textTransform: "none",
    color: theme.palette.primary.main,
  },

  ripple: {
    color: theme.palette.primary.main,
  },

  selectedText: {
    fontWeight: "bold",
  },

  selectedIcon: {
    color: "inherit",
  },
}));

const NavigationMenuLink = props => {
  const { icon, primary, to, onClick } = props;
  const location = useLocation();
  const classes = useStyles();
  const selected = equals(to, location.pathname);

  const renderLink = React.useMemo(
    () =>
      React.forwardRef((itemProps, ref) => (
        <Link to={to} {...itemProps} ref={ref} />
      )),
    [to],
  );

  return (
    <li>
      <ListItem
        button
        onClick={onClick}
        selected={selected}
        component={renderLink}
        classes={{
          root: classes.root,
          selected: classes.selected,
        }}
      >
        {icon ? (
          <ListItemIcon className={clsx({ [classes.selectedIcon]: selected })}>
            {icon}
          </ListItemIcon>
        ) : null}
        <ListItemText
          disableTypography={true}
          primary={primary}
          classes={{ root: classes.itemText }}
          className={clsx({ [classes.selectedText]: selected })}
        />
      </ListItem>
    </li>
  );
};

export default NavigationMenuLink;
